import React, { useState } from 'react';
import { FaMap } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { Button, Modal, ModalBody, ModalHeader, Table } from 'reactstrap';
import Swal from 'sweetalert2';
import ReactJson from 'react-json-view';
import api from '../../services/api';
import { Translator } from '../../components/i18n';

function ModalLog({ data, setData }) {
  const [geojson, setGeojson] = useState(false);

  const handleGeojson = async (obj) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const { data: res } = await api.get(`/mapa/${obj?.objeto}`);
      setGeojson({
        obj,
        mapa: res,
      });
    } catch (err) {
      toast.error(err?.response?.data?.error);
    }
    Swal.close();
  };

  return (
    <>
      <Modal isOpen={!!data} toggle={() => setData(false)} size="lg">
        <ModalHeader toggle={() => setData(null)}>
          <Translator path="mapa.logtalhao.label" />
        </ModalHeader>
        <ModalBody>
          <Table responsive>
            <thead>
              <tr>
                <th className="text-center">
                  <Translator path="mapa.logtalhao.grid.talhao" />
                </th>
                <th className="text-center">
                  <Translator path="mapa.logtalhao.grid.tipo" />
                </th>
                <th className="text-center">
                  <Translator path="mapa.logtalhao.grid.ultimaalteracao" />
                </th>
                <th className="text-center">Geojson</th>
              </tr>
            </thead>
            <tbody>
              {data?.length ? (
                data?.map((c) => (
                  <tr key={c?.objeto}>
                    <td className="text-center">{c?.Talhao?.descricao}</td>
                    <td className="text-center">{c?.origem}</td>
                    <td className="text-center">
                      {`${new Date(
                        c?.updated_at || c?.updatedAt
                      ).toLocaleDateString('pt-BR')} ${new Date(
                        c?.updated_at || c?.updatedAt
                      )
                        .toLocaleTimeString('pt-BR')
                        .substring(0, 5)}`}
                    </td>
                    <td className="text-center">
                      <Button
                        color="link p-0"
                        onClick={() => {
                          handleGeojson(c);
                        }}
                      >
                        <FaMap />
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4}>
                    <Translator path="excecoes.semregistros" />
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>

      <Modal isOpen={!!geojson} toggle={() => setGeojson(false)} size="lg">
        <ModalHeader toggle={() => setGeojson(false)}>
          Geojson {geojson?.obj?.Talhao?.descricao} - {geojson?.obj?.origem} -{' '}
          {`${new Date(
            geojson?.obj?.updated_at || geojson?.obj?.updatedAt
          ).toLocaleDateString('pt-BR')} ${new Date(
            geojson?.obj?.updated_at || geojson?.obj?.updatedAt
          )
            .toLocaleTimeString('pt-BR')
            .substring(0, 5)}`}
        </ModalHeader>
        <ModalBody>
          <ReactJson src={geojson?.mapa} displayDataTypes={false} />
        </ModalBody>
      </Modal>
    </>
  );
}

function areEqual(prevProps, nextProps) {
  return !!prevProps?.data === !!nextProps?.data;
}
export default React.memo(ModalLog, areEqual);
